__turbopack_context__.v({
  "modalBody": "TermsOfPurchaseModal-module-scss-module__7YM8OW__modalBody",
  "modalContent": "TermsOfPurchaseModal-module-scss-module__7YM8OW__modalContent",
  "modalFooter": "TermsOfPurchaseModal-module-scss-module__7YM8OW__modalFooter",
  "modalHeader": "TermsOfPurchaseModal-module-scss-module__7YM8OW__modalHeader",
});
